import { useTranslation } from '@parsina/framework/clinical/src/i18n/index';
import { C } from '@parsina/framework/clinical/src/constants/theme';
import { CT, soft } from '@parsina/framework/tokens';
import { Button } from '@parsina/framework';

// The forgotten-visit alert (mobile concept §4): a visit left open (> 2h, or from
// a previous day) follows the doctor to every date until continued or closed —
// being out of sight is how it got forgotten. Closing goes through the screen's
// ConfirmDialog (the onEnd callback asks; this card never completes a visit
// directly).


const MobileForgottenVisitAlert = ({ visits, onContinue, onEnd }) => {
  const { t } = useTranslation();
  if (!visits.length) return null;

  return (
    <>
      {visits.map(apt => (
        <div
          key={apt.id}
          data-testid={`reception-forgotten-${apt.id}`}
          style={{
            margin: '0.75rem 0.875rem 0', background: C.redLight, border: `1.5px solid ${soft(C.red, 0.35)}`,
            borderRadius: '0.75rem', padding: '0.625rem 0.75rem',
            display: 'flex', alignItems: 'center', gap: '0.5rem', flexWrap: 'wrap',
          }}
        >
          <span style={{ fontSize: '0.625rem', fontWeight: 800, borderRadius: '0.75rem', padding: '0.125rem 0.5rem', background: soft(C.red, 0.12), color: CT.dangerInk }}>
            {t('dashboard.forgotten.title')}
          </span>
          <span style={{ flex: 1, minWidth: '7.5rem', fontSize: '0.75rem', fontWeight: 700, color: CT.dangerInk }}>
            {apt.name || t('common.labels.patient')}
          </span>
          <Button
            variant="outline" size="sm"
            data-testid={`reception-forgotten-continue-${apt.id}`}
            className="min-h-11 text-xs font-bold"
            style={{ color: CT.dangerInk, borderColor: soft(C.red, 0.35) }}
            onClick={() => onContinue(apt)}
          >{t('dashboard.hero.continueShort')}</Button>
          <Button
            variant="destructive" size="sm"
            data-testid={`reception-forgotten-end-${apt.id}`}
            className="min-h-11 text-xs font-extrabold"
            onClick={() => onEnd(apt)}
          >{t('dashboard.hero.endShort')}</Button>
        </div>
      ))}
    </>
  );
};

export default MobileForgottenVisitAlert;
